import { formatDateTime } from "@demandproai/shared";
import { DeleteNoteButton } from "../../../../components";
import { noteItemClasses, deleteNoteBtnClasses } from "../../../../components/common/listItemClasses";
import XModal from "../../../../components/common/XModal";

const messageContainerClasses = "max-w-[calc(var(--spacing)*150)] mb-5";

const bubbleClasses =
    "bg-surface-alt px-4 py-3 rounded-md text-sm text-content " +
    "leading-normal whitespace-pre-wrap break-words [overflow-wrap:anywhere]";

const metaClasses =
    "flex justify-between text-sm font-semibold text-disabled mb-1.5";

const ViewAllCaseNoteModal = ({ isOpen, setIsOpen, noteList, deleteNote }) => {
    return (
        <XModal
            isOpen={isOpen}
            title="Case Notes"
            onClose={() => setIsOpen(false)}
            size="sm"
        >
            {noteList && noteList?.map((note, i) => (
                <div className={messageContainerClasses} key={i}>
                    <div className={`${bubbleClasses} ${noteItemClasses}`}>
                        <div className={metaClasses}>
                            <span>{note?.createdBy?.firstName} {note?.createdBy?.lastName}</span>
                            <span>{formatDateTime(note?.createdAt)}</span>
                        </div>
                        {note.text}
                        <div className={deleteNoteBtnClasses}>
                            <DeleteNoteButton onClick={() => deleteNote(note._id)} />
                        </div>
                    </div>
                </div>
            ))}
        </XModal>
    );
};

export default ViewAllCaseNoteModal;